import { type IBooleanCondition } from '../../../../inputs/expressions-editor/conditions/IBooleanCondition.tsx';

export enum CustomWarningRuleType {
  Warning = 'warning',
  Error = 'error',
}

export interface ICustomWarningRule {
  type: CustomWarningRuleType;
  message: string;
  condition: IBooleanCondition;
}
